<template>
<v-layout column justify-center class="titlebar">
  <v-layout  row>
  <div v-bind:class="{ 'pageSubtitle light': !this.small, 'titlebar-title-small': this.small }" >{{title}}</div>
  <v-spacer></v-spacer>
  <slot name="actionButton" />
  </v-layout>
  <v-layout class="helperText" row>
    <slot name="helperText"/>
  </v-layout>
</v-layout>
</template>

<style lang="scss" scoped>
$height: 48px;

.titlebar {
  // background-color: #eee;
  
  margin-bottom: 14px;
}

.pageTitle.light {
  opacity: .10;
}
.helperText {
  font-size: 18px;
  font-weight: 300;
  text-align: left;
  color: #666;
  padding-bottom: 0px;
}

.titlebar-title {
  font-size: 24px;
  // font-weight: bold;
  font-weight: 700;
  text-align: left;
  color: black;
  padding-bottom: 0px;
}

.titlebar-title-small {
font-size: 20px;
  // font-weight: bold;
  font-weight: 700;
  text-align: left;
  color: #666;
  padding-bottom: 0px;
}
</style>

<script>
export default {
  name: 'OneTitlebar',
  props: {
    title: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Titlebar.vue